import { Outlet, useLocation } from 'react-router-dom';
import BottomNav from './BottomNav';

function Layout() {
  const location = useLocation();

  return (
    <div className="relative min-h-screen overflow-hidden bg-telegram-bg text-telegram-text">
      <main className="relative z-10 flex-1 overflow-y-auto pb-20">
        <div key={location.pathname} className="page-transition h-full">
          <Outlet />
        </div>
      </main>
      <BottomNav />
    </div>
  );
}

export default Layout;
